var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPageFW,[_c(_setup.LocationHeader,{attrs:{"route-name":"talent-pool-jobs","location-id":_setup.locationId,"divider":true}}),_c(_setup.GetStartedJobs),_c(_setup.AddJobModal)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }